import type { CreateTokenDetailsFormData } from "@repo/shared-types";
import { useState } from "react";

import { Button } from "../ui/Button";
import { Input } from "../ui/Input";

type SocialLinksPlatform = keyof NonNullable<CreateTokenDetailsFormData["socialLinks"]>;

type SocialLinksSectionProps = {
	socialLinks: NonNullable<CreateTokenDetailsFormData["socialLinks"]>;
	errors: Partial<Record<string, string>>;
	onSocialLinkChange: (platform: SocialLinksPlatform, value: string) => void;
};

const socialFields: Array<{ platform: SocialLinksPlatform; label: string; placeholder: string }> = [
	{ platform: "website", label: "Website", placeholder: "https://yourwebsite.com" },
	{ platform: "twitter", label: "Twitter", placeholder: "https://twitter.com/yourhandle" },
	{ platform: "discord", label: "Discord", placeholder: "https://discord.gg/yourserver" },
	{ platform: "telegram", label: "Telegram", placeholder: "https://t.me/yourchannel" },
];

export function SocialLinksSection({
	socialLinks,
	errors,
	onSocialLinkChange,
}: SocialLinksSectionProps) {
	const [showSocialLinks, setShowSocialLinks] = useState(false);

	return (
		<div>
			<div className="flex items-center justify-between mb-4">
				<span className="text-sm font-medium text-pastel-black">Social Links (Optional)</span>
				<Button variant="ghost" size="sm" onClick={() => setShowSocialLinks(!showSocialLinks)}>
					{showSocialLinks ? "Hide" : "Add"}
				</Button>
			</div>

			{showSocialLinks && (
				<div className="space-y-4">
					{socialFields.map(({ platform, label, placeholder }) => (
						<Input
							key={platform}
							label={label}
							placeholder={placeholder}
							value={socialLinks[platform] || ""}
							onChange={(e) => onSocialLinkChange(platform, e.target.value)}
							error={errors[`socialLinks.${platform}`] || ""}
						/>
					))}
				</div>
			)}
		</div>
	);
}
